module.exports = __webpack_public_path__ + "static/media/MicroIcon.2beac1d3.svg";